import { jsx as o } from "react/jsx-runtime";
import { $ as l } from "./index-D_37ItTm.js";
import { S as b } from "./Spinner-BAG4k2UR.js";
import * as $ from "react";
import { c as d } from "./index-SYE1cn5_.js";
const B = $.forwardRef(function({
  children: r,
  variant: s = "solid",
  color: e = "primary",
  size: a = "lg",
  isOnlyIcon: n = !1,
  disabled: m = !1,
  className: c,
  asChild: p,
  upperCase: u = !0,
  loading: t = !1,
  ...i
}, f) {
  return /* @__PURE__ */ o(
    p ? l : "button",
    {
      ref: f,
      className: d(
        "button",
        `button--${e}--${s}`,
        `button--${a}`,
        {
          "button--only-icon": n,
          "button--uppercase": u,
          "button--loading": t
        },
        c
      ),
      disabled: m || t,
      ...i,
      children: t ? /* @__PURE__ */ o(b, { size: "sm" }) : r
    }
  );
});
B.displayName = "Button";
export {
  B
};
